<div *ngIf="!isHidden" [ngSwitch]="input.type" [ngClass]="{ required: input.required }" [formGroup]="form">
	<div *ngSwitchCase="'text'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<input
			stagesTrim
			[type]="input.inputFieldType"
			[id]="input.key"
			class="text fullsize"
			[formControlName]="input.key"
			[readonly]="input.readonly"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			(focus)="input.expand ? input.expand() : nop()"
			stagesAutofocus
			*ngIf="input.focus"
		/>
		<input
			stagesTrim
			[type]="input.inputFieldType"
			[id]="input.key"
			class="text fullsize"
			[formControlName]="input.key"
			[readonly]="input.readonly"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			(focus)="input.expand ? input.expand() : nop()"
			(change)="onValueChange(input)"
			*ngIf="!input.focus"
		/>
		<div class="info">
			<div
				*ngIf="input.infoMsgKey && !hasErrors(formControl)"
				class="info-message"
				[translate]="input.infoMsgKey"
			></div>
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error">
					<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
					<div
						*ngSwitchCase="'maxlength'"
						class="error"
						translate="input.maxLength"
						[translateParams]="{ length: input.maxLength }"
						role="alert"
					></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div *ngIf="input.maxLength" class="maxlength">{{ getInputLength() }}/{{ input.maxLength }}</div>
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'checkbox'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<input [type]="input.inputFieldType" hidden="hidden" [formControlName]="input.key" [checked]="formControl.value" />
		<!--	if we use a custom toogle function the default input brwoser behaviour is overwritten	-->
		<!--	and the disabled attribute is not working	-->
		<!--	nevertheless with some magic the disabled attribute is somehow added to the input element (maybe from the dormControl?!	-->
		<!--	the line below was the try with the disabled attribute	-->
		<!--		[attr.disabled]="input.disabled ? 'disabled' : null"   -->
		<label [for]="input.key" class="switch" (click)="toggleCheckbox()"></label>

		<div class="info">
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
			<div *ngIf="input.warnMsgKey" class="warning-color">
				<p><span class="ico ico-warning ico-inline"></span> {{ input.warnMsgKey | translate }}</p>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'radio'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<div
			class="radio"
			*ngFor="
				let option of selectionOptions | orderAlphabetically : getOptionLabel : isAlphabeticallyOrderedSelection()
			"
		>
			<input
				[id]="option.value"
				[type]="input.inputFieldType"
				[formControlName]="input.key"
				[value]="option.value"
				[checked]="formControl.value === option.value"
				(change)="onValueChange(input)"
				[name]="input.key"
				[attr.disabled]="input.disabled ? 'disabled' : null"
			/>
			<label [for]="option.value" (click)="selectRadioChoice(option.value)">{{ option.value }}</label>
		</div>
		<div class="info">
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
			<div *ngIf="input.warnMsgKey" class="warning-color">
				<p><span class="ico ico-warning ico-inline"></span> {{ input.warnMsgKey | translate }}</p>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'selection'" [ngClass]="{ required: input.required }">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<select
			[id]="input.key"
			[formControlName]="input.key"
			class="fullsize"
			[size]="size"
			[multiple]="isMultiSelect()"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			(change)="onValueChange(input)"
		>
			<option
				*ngFor="
					let option of selectionOptions | orderAlphabetically : getOptionLabel : isAlphabeticallyOrderedSelection()
				"
				[value]="option.value"
			>
				{{ getOptionLabel(option) }}
			</option>
		</select>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error" role="alert">
					<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
				</ng-container>
			</div>
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
			<div
				*ngIf="input.infoMsgKey && !hasErrors(formControl)"
				class="info-message"
				[translate]="input.infoMsgKey"
			></div>
		</div>
	</div>

	<div *ngSwitchCase="'password'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<input
			[type]="input.inputFieldType"
			[id]="input.key"
			class="text fullsize"
			[formControlName]="input.key"
			[readonly]="input.readonly"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			autocomplete="new-password"
		/>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error" role="alert">
					<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
					<div
						*ngSwitchCase="'maxlength'"
						class="error"
						translate="input.maxLength"
						[translateParams]="{ length: input.maxLength }"
						role="alert"
					></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div *ngIf="input.maxLength" class="maxlength">{{ getInputLength() }}/{{ input.maxLength }}</div>
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'textarea'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<textarea
			*ngIf="input.placeholderKey"
			stagesTrim
			[id]="input.key"
			class="text plaintext-input"
			[formControlName]="input.key"
			[readonly]="input.readonly"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			[placeholder]="input.placeholderKey | translate"
			stagesAutoGrow
		>
		</textarea>
		<textarea
			*ngIf="!input.placeholderKey || input.placeholderKey === undefined"
			stagesTrim
			[id]="input.key"
			class="text plaintext-input"
			[formControlName]="input.key"
			[readonly]="input.readonly"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			stagesAutoGrow
		>
		</textarea>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error" role="alert">
					<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
					<div
						*ngSwitchCase="'maxlength'"
						class="error"
						translate="input.maxLength"
						[translateParams]="{ length: input.maxLength }"
						role="alert"
					></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div *ngIf="input.maxLength" class="maxlength">{{ getInputLength() }}/{{ input.maxLength }}</div>
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'json'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<textarea
			[id]="input.key"
			class="text plaintext-input"
			[formControlName]="input.key"
			[readonly]="input.readonly"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			stagesAutoGrow
		>
		</textarea>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error" role="alert">
					<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
					<div
						*ngSwitchCase="'maxlength'"
						class="error"
						translate="input.maxLength"
						[translateParams]="{ length: input.maxLength }"
						role="alert"
					></div>
					<div *ngSwitchCase="'json'" class="error" translate="input.notValid" role="alert"></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
		</div>
	</div>

	<ng-container [ngSwitch]="true">
		<div *ngSwitchCase="input.type === 'number'" class="form-wrapper" appInvalidControlScrollContainer>
			<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
			<input
				[type]="input.inputFieldType"
				[id]="input.key"
				class="text fullsize"
				[formControlName]="input.key"
				[readonly]="input.readonly"
				[attr.disabled]="input.disabled ? 'disabled' : null"
				(change)="onValueChange(input)"
				stagesValidateOnBlur
			/>
			<div class="info">
				<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
					<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error" role="alert">
						<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
						<div *ngSwitchCase="'integer'" class="error" translate="input.integer" role="alert"></div>
						<div *ngSwitchCase="'min'" class="error" translate="input.minNumber" role="alert"></div>
						<div *ngSwitchCase="'max'" class="error" translate="input.maxNumber" role="alert"></div>
						<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
					</ng-container>
				</div>
				<div *ngIf="input.helpMessage" class="help">
					<p>{{ input.helpMessage }}</p>
				</div>
			</div>
		</div>
	</ng-container>
	<div *ngSwitchCase="'date'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<input
			[type]="input.inputFieldType"
			[id]="input.key"
			class="text fullsize"
			[formControlName]="input.key"
			[readonly]="input.readonly"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			(change)="onValueChange(input)"
		/>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error">
					<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
					<div
						*ngSwitchCase="'date'"
						class="error"
						translate="input.pattern.date"
						[translateParams]="{ format: 'yyyy-MM-dd' }"
						role="alert"
					></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'ids'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<input
			[type]="input.inputFieldType"
			[id]="input.key"
			class="text fullsize"
			[formControlName]="input.key"
			[readonly]="input.readonly"
			[attr.disabled]="input.disabled ? 'disabled' : null"
			(change)="onValueChange(input)"
		/>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error">
					<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
					<div *ngSwitchCase="'ids'" class="error" translate="input.ids" role="alert"></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'rich_text'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<stages-description-editor
			#descriptionComp
			[formControlName]="input.key"
			[editorId]="input.key"
			[modifiable]="!input.readonly"
			[unsafe]="false"
			[processTypeIdent]="richtextInput.processTypeIdent!"
			[pluginRegistry]="richtextInput.pluginRegistry"
			[workspaceId]="richtextInput.workspaceId"
			[beanType]="richtextInput.beanType ?? 'process'"
			[beanId]="richtextInput.beanId"
			[beanIdentity]="richtextInput.beanIdentity"
			[properties]="richtextInput.properties"
			[pv]="richtextInput.pv"
			[focus]="richtextInput.focus"
			[deactivateFloatingButton]="richtextInput.deactivateFloatingButton"
		>
		</stages-description-editor>

		<div class="info"></div>
	</div>

	<div *ngSwitchCase="'duration'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<div class="duration-input">
			<div>
				<input
					stagesTrim
					type="number"
					[id]="input.key"
					class="text duration-value"
					[formControlName]="input.key"
					[readonly]="!!$any(input).enabledKey && form.get($any(input).enabledKey)!.value === false"
					[attr.disabled]="input.disabled ? 'disabled' : null"
					(change)="onValueChange(input)"
				/>
				<select
					[id]="$any(input).unitKey"
					[formControlName]="$any(input).unitKey"
					[multiple]="false"
					[attr.disabled]="input.disabled ? 'disabled' : null"
					class="duration-unit"
				>
					<option *ngFor="let option of selectionOptions" [value]="option.value">
						{{ getOptionLabel(option) }}
					</option>
				</select>
			</div>
			<ng-container *ngIf="!!$any(input).enabledKey">
				<input
					type="checkbox"
					hidden="hidden"
					[formControlName]="$any(input).enabledKey"
					class="duration-enabled"
					[name]="$any(input).enabledKey"
					[id]="$any(input).enabledKey"
					(change)="
						$any(input).setDisabled(formControl, form.get($any(input).unitKey)!, form.get($any(input).enabledKey)!)
					"
				/>
				<label [for]="$any(input).enabledKey" class="switch"></label>
			</ng-container>
		</div>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error" role="alert">
					<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
					<div *ngSwitchCase="'integer'" class="error" translate="input.integer" role="alert"></div>
					<div *ngSwitchCase="'min'" class="error" translate="input.minNumber" role="alert"></div>
					<div *ngSwitchCase="'max'" class="error" translate="input.maxNumber" role="alert"></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div *ngIf="input.helpMessage" class="help">
				<p>{{ input.helpMessage }}</p>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'reminder'" [formGroup]="$any(input).form">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<div class="reminder-list">
			<div
				class="reminder-item"
				formArrayName="reminder"
				*ngFor="let duration of $any(input).reminderFormArray.controls; let i = index"
			>
				<div class="reminder-controls">
					<ng-container [formGroupName]="i">
						<div>
							<input
								stagesTrim
								type="number"
								class="text duration-value"
								formControlName="value"
								[readonly]="$any(input).getEnabledControl(i).value === false"
								[attr.disabled]="$any(input).getEnabledControl(i).value === false ? 'disabled' : null"
								(change)="onValueChange(input)"
							/>
							<select
								formControlName="unit"
								[multiple]="false"
								[attr.disabled]="$any(input).getEnabledControl(i).value === false ? 'disabled' : null"
								class="duration-unit"
							>
								<option *ngFor="let option of selectionOptions" [value]="option.value">
									{{ getOptionLabel(option) }}
								</option>
							</select>
						</div>

						<div>
							<button (click)="$any(input).removeReminder(i)" class="button clickable trash">
								<i class="ico ico-delete"></i>
							</button>

							<input
								type="checkbox"
								hidden="hidden"
								class="duration-enabled"
								formControlName="enabled"
								[name]="'enabled' + i"
								[id]="'enabled' + i"
								(change)="$any(input).setDisabled(i)"
							/>
							<label [for]="'enabled' + i" class="switch"></label>
						</div>
					</ng-container>
				</div>

				<div>
					<div
						*ngIf="
							hasErrors($any(input).getValueControl(i)) &&
							($any(input).getValueControl(i).dirty || $any(input).getValueControl(i).touched)
						"
					>
						<ng-container
							*ngFor="let error of $any(input).getErrors($any(input).getValueControl(i))"
							[ngSwitch]="error"
							role="alert"
						>
							<div *ngSwitchCase="'required'" class="error" translate="input.required" role="alert"></div>
							<div *ngSwitchCase="'number'" class="error" translate="input.integer" role="alert"></div>
							<div *ngSwitchCase="'min'" class="error" translate="input.minNumber" role="alert"></div>
							<div *ngSwitchCase="'max'" class="error" translate="input.maxNumber" role="alert"></div>
							<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
						</ng-container>
					</div>
				</div>
			</div>

			<div class="buttons">
				<button type="button" class="flat" (click)="$any(input).addReminder()">add reminder</button>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'escalation'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<ng-container [formGroupName]="input.key">
			<div class="escalation-input">
				<div>
					<select
						formControlName="stakeholder"
						[multiple]="false"
						[attr.disabled]="input.disabled ? 'disabled' : null"
						class="escalation-stakeholder"
					>
						<option *ngFor="let option of $any(input).stakeholders" [value]="option.value">
							{{ getOptionLabel(option) }}
						</option>
					</select>
					<select
						formControlName="frequency"
						[multiple]="false"
						[attr.disabled]="input.disabled ? 'disabled' : null"
						class="escalation-frequency"
					>
						<option *ngFor="let option of $any(input).frequencies" [value]="option.value">
							{{ getOptionLabel(option) }}
						</option>
					</select>
				</div>
				<ng-container>
					<input
						type="checkbox"
						hidden="hidden"
						formControlName="enabled"
						[name]="input.key + 'enabled'"
						[id]="input.key + 'enabled'"
						class="duration-enabled"
						(change)="$any(input).setDisabled()"
					/>
					<label [for]="input.key + 'enabled'" class="switch"></label>
				</ng-container>
			</div>
			<div class="info">
				<div *ngIf="input.helpMessage" class="help">
					<p>{{ input.helpMessage }}</p>
				</div>
			</div>
		</ng-container>
	</div>

	<div *ngSwitchCase="'color'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<div class="color-input">
			<stages-color-picker
				[formControlName]="input.key"
				[required]="input.required!"
				[maxLengthOfInput]="input.maxLength!"
				[colorPalette]="$any(input).colorPalette"
				[orientation]="$any(input).orientation"
			></stages-color-picker>
		</div>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error">
					<div *ngSwitchCase="'required'" class="error" [translate]="'input.required'" role="alert"></div>
					<div
						*ngSwitchCase="'maxlength'"
						class="error"
						[translate]="'input.maxLength'"
						[translateParams]="{ length: input.maxLength }"
						role="alert"
					></div>
					<div *ngSwitchCase="'pattern'" class="error" [translate]="'processrelease.states.edit.color.pattern'"></div>
				</ng-container>
			</div>
			<div
				*ngIf="input.infoMsgKey && !hasErrors(formControl)"
				class="info-message"
				[translate]="input.infoMsgKey"
			></div>
		</div>
	</div>

	<div *ngSwitchCase="'date_time'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<ng-container *ngIf="$any(input).oldVersion">
			<input
				stagesTrim
				[type]="input.inputFieldType"
				[id]="input.key"
				class="text fullsize"
				[formControlName]="input.key"
				[readonly]="input.readonly"
				[attr.disabled]="input.disabled ? 'disabled' : null"
				(focus)="input.expand ? input.expand() : nop()"
				(change)="onValueChange(input)"
				*ngIf="!input.focus"
				[attr.step]="1"
			/>
		</ng-container>

		<ng-container *ngIf="!$any(input).oldVersion">
			<stages-date-time-picker
				[formControlName]="input.key"
				[placeholder]="input.placeholderKey ? (input.placeholderKey | translate) : ''"
				[setDate]="$any(input.value)"
				[initialHoursOffset]="$any(input).initialHoursOffset"
				[isDateTimeDisabled]="!!input.disabled"
			></stages-date-time-picker>
		</ng-container>

		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error">
					<div *ngSwitchCase="'required'" class="error" [translate]="'input.required'" role="alert"></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div
				*ngIf="input.infoMsgKey && !hasErrors(formControl)"
				class="info-message"
				[translate]="input.infoMsgKey"
			></div>
		</div>
	</div>

	<div *ngSwitchCase="'time'">
		<label class="input-label" [for]="input.key">{{ fieldLabel }}</label>
		<input
			stagesTrim
			[id]="input.key"
			[type]="'time'"
			[attr.step]="1"
			[class]="'text fullsize'"
			[formControlName]="input.key"
			[placeholder]="input.placeholderKey ? (input.placeholderKey | translate) : ''"
			[name]="input.key + 'enabled'"
			(change)="onValueChange(input)"
		/>
		<div class="info">
			<div *ngIf="hasErrors(formControl) && (formControl.dirty || formControl.touched)">
				<ng-container *ngFor="let error of getErrors()" [ngSwitch]="error">
					<div *ngSwitchCase="'required'" class="error" [translate]="'input.required'" role="alert"></div>
					<div *ngSwitchDefault class="error" [translate]="input.errorKey + '.' + error" role="alert"></div>
				</ng-container>
			</div>
			<div
				*ngIf="input.infoMsgKey && !hasErrors(formControl)"
				class="info-message"
				[translate]="input.infoMsgKey"
			></div>
		</div>
	</div>
</div>
